import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserIdleService } from 'angular-user-idle';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { Network } from '@ngx-pwa/offline';
import { StorageService } from 'src/app/services/storage.service';
import { AuthFacade } from 'src/app/ngrx/auth/auth.facade';

@Component({
  selector: 'app-user-idle-modal',
  templateUrl: './user-idle-modal.component.html',
  styleUrls: ['./user-idle-modal.component.scss']
})
export class UserIdleModalComponent implements OnInit {
  username = '';
  password = '';
  alerts: any[] = [];
  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthenticationService,
    private userIdle: UserIdleService,
    private storage: StorageService,
    private network: Network,
    private authFacade: AuthFacade
  ) { }

  ngOnInit() {
  }

  logout() {
    this.authService.logout();
    this.bsModalRef.hide();
  }

  login() {
    const payload = {
      username: this.username,
      password: this.password,
      grant_type: 'password'
    };

    if (this.password === '' || this.username === '') {
      this.alerts.push({
        type: 'danger',
        msg: 'Username and Password are required!',
        timeout: 5000
      });
      return;
    }

    this.authService.processLogin(payload).subscribe(data => {
      if (data.error !== undefined) {
        this.alerts.push({
          type: 'danger',
          msg: data.error.error_description !== undefined ? data.error.error_description : 'Network Error!',
          timeout: 5000
        });
      } else {
        this.authFacade.insertDataToDB(data);
        this.storage.setLocalValue('selectedAssignedAgentId', data.agent_id);
        this.userIdle.resetTimer();
        this.bsModalRef.hide();
      }
    });
  }

  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

}
